import { createContext, useContext } from 'react';

export type Context = {
	orgId?: string;
	subproduct?: string;
	tenantId?: string;
	isSiteAdmin?: boolean;
	workspaceId?: string;
	locale: string | undefined;
	product: string | undefined;
	unread?: boolean;
};

export const PostOfficeContext = createContext<Context>({
	product: undefined,
	locale: undefined,
});

export const PostOfficeContextProvider = PostOfficeContext.Provider;

export const usePostOfficeContext = () => useContext(PostOfficeContext);
